import {createSharedValueKey, useSharedValue} from '@epic-core/hooks';
import {ImageProps} from '../../elements';

export const communityActiveIndexKey = createSharedValueKey<number | null>(
    'communityActiveIndexKey',
    null
);
interface CommunityActiveIndexRes {
    communityActiveIndex: number | null;
    setCommunityActiveIndex: (arg: number | null) => void;
}
export const useCommunityActiveIndex = (): CommunityActiveIndexRes => {
    const [communityActiveIndex, setCommunityActiveIndex] = useSharedValue(communityActiveIndexKey);
    return {
        communityActiveIndex,
        setCommunityActiveIndex
    };
};

export const communitySpotlightImageKey = createSharedValueKey<ImageProps | undefined>(
    'communitySpotlightImage',
    undefined
);
interface CommunitySpotlightImageRes {
    communitySpotlightImage: ImageProps | undefined;
    setCommunitySpotlightImage: (arg: ImageProps) => void;
}
export const useCommunitySpotlightImage = (): CommunitySpotlightImageRes => {
    const [communitySpotlightImage, setCommunitySpotlightImage] = useSharedValue(
        communitySpotlightImageKey
    );
    return {
        communitySpotlightImage,
        setCommunitySpotlightImage
    };
};
